import { useLocation } from "react-router";
import { Table } from "../../features/Table";
import {
  type FinancialIndicator,
  financial_indicator_columns,
} from "./columns";
import { FilterFinancialIndicators } from "./filter";

const client = "instit-quantilia";
const table_name = "financial_indicators";

export const FinancialIndicatorsTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;

  return (
    <Table<FinancialIndicator, FinancialIndicator>
      label="Financial Indicators"
      client={client}
      table_name={table_name}
      columns={financial_indicator_columns}
      filter={<FilterFinancialIndicators />}
      disable_translations_request={true}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
